import { styled } from '@material-ui/core'
import { TOOLBAR_HEIGHT } from '../config'

export const ListWrapper = styled('div')({
  display: 'flex',
  width: '100%',
  height: `calc(100vh - ${TOOLBAR_HEIGHT}px)`,
})
